<template>
	<div>
		<div class="card" onclick="this.classList.toggle('expanded')">
			<!-- <svg class="label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height="200" width="200"><path d="M9.875 23.825L51.14 0l41.267 23.825v47.65L51.14 95.3 9.876 71.475v-47.65" fill="#463833"/><path d="M12.067 25.09L51.14 2.533l39.075 22.56v45.117L51.14 92.767l-39.073-22.56V25.092" fill="#d8ae4b"/><path d="M90.215 70.21v-.385c-.567.33-1.165.608-1.8.817-1.417.572-2.888.834-4.412.786-1.164-.188-2.327-.383-3.488-.586-1.703-.132-3.397.283-5.104.27-.484 0-.98-.047-1.464-.042-2.222.026-4.086 1.743-6.32 1.62-1.067-.06-.878-.708-1.037-1.635-.14-.81-.15-1.728-1.11-1.846-.604.1-1.207.202-1.81.31-1.058.138-1.972.117-2.99-.155-.522-.14-1.064-.365-1.607-.406-.303.008-.603.028-.903.06-.995-.202-1.576-1.353-2.277-1.99-1.42-1.288-2.833-.705-4.542-.416-1.03.175-2.25.664-3.07-.228-1.108-1.208-.726-2.866-2.477-3.556-.848-.335-1.897-.503-2.8-.576-1.415-.116-3.192-.087-4.35-1.065-.512-.435-.793-1.005-.845-1.71-.42-1.423-.965-2.793-1.637-4.114-1.408-2.105-3.755-.843-5.66-2.055-1.545-.982-2.275-3.353-2.903-4.93-.632-1.583-1.026-3.666-2.212-4.97-.425-.502-.948-.845-1.57-1.03-1.044-.593-1.635-1.945-2.046-3.025-.532-1.39-.56-4.61-2.203-5.24-1.324-.51-3.134.655-4.426-.258-1.46-1.033-1.137-5.008-1.116-6.35.018-1.182.098-2.464.28-3.713l-2.247 1.297v45.12L51.14 92.767l39.075-22.56" fill="#d49235"/><path d="M36.298 11.102c.048.043.098.08.146.128 1.453 1.418 2.48 1.178 4.457.987.837-.087 1.676-.116 2.516-.088.772 0 1.013.12 1.592.255 1.095.253 2.128-.235 3.012-.905.532-.555 1.13-1.03 1.79-1.42.783-.234.825.122 1.248.62.716.843 1.063 1.126 2.108 1.51 1.414.517 2.293 1.32 2.573 2.792.08.437.063 1.373.433 1.702.49.118.984.112 1.48-.02 1.025-.133 2.115-.452 3.152-.204 1.014.24 1.84.933 2.852 1.19 1.192.3 2.315.26 3.533.278.543-.03 1.065.058 1.568.258.654.428.58 1.5.94 2.11.526.887 1.453 1 2.44 1.03 1.33.042 2.688-.303 3.425 1.18.536 1.078.044 2.27.272 3.384 1.27.39 2.694-.897 4.037-.516 1.58.45 2.835 2.128 4.247 2.904.65.357 1.312.397 1.958.88.687.517.84.874 1.132 1.665.524 1.416 1.23 3 2.294 4.102.23.237.468.46.71.677v-10.51L51.142 2.53 36.3 11.102" fill="#efc65f"/><path d="M14.92 26.738L51.14 5.825l36.222 20.913v41.825l-36.22 20.912L14.92 68.563z" fill="none" stroke="#463833" stroke-width=".588" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="2.35002902, 2.35002902"/><g fill="#463833"><g><path d="M26.392 39.442q-2.39 0-3.803 1.813-1.402 1.813-1.402 4.94 0 3.118 1.4 4.93 1.414 1.813 3.804 1.813 2.39 0 3.78-1.812 1.403-1.813 1.403-4.93 0-3.128-1.402-4.94-1.39-1.814-3.78-1.814zm3.075 14.69l2.89 3.217h-2.65l-2.402-2.643-.554.033q-.184.01-.358.01-3.423 0-5.476-2.32-2.043-2.332-2.043-6.234 0-3.913 2.043-6.234 2.053-2.333 5.476-2.333 3.412 0 5.454 2.332 2.043 2.32 2.043 6.234 0 2.874-1.142 4.92-1.13 2.043-3.28 3.016zM34.156 49.545V42.05h2v7.418q0 1.757.673 2.64.673.875 2.02.875 1.62 0 2.553-1.05.946-1.05.946-2.863v-7.02h1.998v12.38h-2v-1.9q-.727 1.127-1.694 1.68-.956.54-2.228.54-2.097 0-3.183-1.325-1.087-1.327-1.087-3.88zM51.375 48.207q-2.423 0-3.358.564-.934.565-.934 1.924 0 1.084.695 1.725.707.63 1.913.63 1.663 0 2.663-1.195 1.01-1.205 1.01-3.194v-.453zm3.987-.84v7.064h-2v-1.88q-.683 1.13-1.705 1.67-1.02.53-2.5.53-1.868 0-2.976-1.06-1.096-1.072-1.096-2.863 0-2.09 1.37-3.15 1.38-1.06 4.106-1.06h2.803v-.2q0-1.404-.913-2.167-.9-.773-2.542-.773-1.043 0-2.032.254-.99.255-1.9.764v-1.88q1.096-.43 2.128-.64 1.032-.222 2.01-.222 2.64 0 3.944 1.393 1.304 1.393 1.304 4.222zM57.037 37.232h2v17.2h-2zM63.29 42.05h2v12.38h-2zm0-4.818h2v2.575h-2zM71.253 38.536v3.515h4.118v1.58h-4.117v6.722q0 1.514.402 1.945.413.43 1.663.43h2.053v1.704H73.32q-2.314 0-3.195-.873-.88-.884-.88-3.205v-6.72h-1.466v-1.58h1.466v-3.516z"/><path d="M80.837 55.58q-.848 2.21-1.652 2.885-.804.674-2.15.674h-1.598v-1.703h1.173q.826 0 1.282-.398.457-.4 1.01-1.88l.36-.928-4.923-12.18h2.118l3.803 9.682 3.804-9.683h2.12z"/></g><path d="M36.213 23.067l3.632 7.746.386-.18-1.493-3.188.73-.343c.933-.437 1.076-1.246.5-2.475l-.394-.84c-.53-1.13-1.235-1.717-2.142-1.29zm2.306 3.913l-1.703-3.63.832-.39c.654-.307 1.127.133 1.52.974l.427.908c.44.94.333 1.476-.347 1.795z" /><path d="M40.19 21.32l2.528 8.173.408-.127-1.13-3.654.646-.2c.71-.22 1.255-.056 1.59 1.03l.398 1.284c.138.444.255.728.437.94l.425-.132c-.216-.227-.35-.595-.454-.934l-.394-1.272c-.274-.888-.715-1.404-1.41-1.393.553-.376.666-1.013.37-1.97l-.22-.713c-.358-1.156-.952-1.727-1.9-1.433zm1.653 3.9l-1.094-3.537.877-.27c.673-.21 1.093.237 1.364 1.112l.24.77c.34 1.098-.004 1.5-.73 1.723z" /><path d="M45.638 23.93l-.56-3.4 2.105-.347-.084-.507-2.528.417 1.393 8.44 2.526-.415-.082-.507-2.106.35-.58-3.523 1.748-.288-.084-.508z" /><path d="M52.362 20.38l.123 7.6.408-.006-.138-8.554-.613.01-1.23 7.586-1.488-7.542-.612.01.14 8.554.38-.006-.124-7.576 1.496 7.542.427-.007z" /><path d="M54.533 19.624l-.986 8.5.424.048.987-8.498z" /><path d="M57.022 19.967l-.417-.09-1.37 6.318c-.26 1.195-.07 2.2.9 2.41.97.21 1.552-.627 1.81-1.822l1.37-6.318-.39-.085-1.374 6.343c-.194.896-.598 1.533-1.296 1.382-.698-.152-.802-.9-.607-1.795z" /><path d="M64.108 23.163l-2.81 7.064.38.15 3.162-7.95-.57-.225-4.055 6.53 1.53-7.535-.57-.227-3.162 7.95.353.14 2.802-7.04-1.52 7.537.395.158z" /><path d="M40.85 65.204c-.71-.64-1.587-.323-2.46.618-1.62 1.747.074 3.37-1.322 4.876-.624.672-1.27.972-1.794.486s-.272-1.152.352-1.824l.324-.35-.3-.277-.3.322c-.838.905-1.154 1.846-.427 2.52.728.676 1.643.29 2.482-.614 1.605-1.728-.09-3.352 1.323-4.875.615-.662 1.263-.978 1.78-.5.516.48.24 1.16-.374 1.822l-.15.16.3.28.124-.135c.84-.905 1.163-1.84.442-2.508z" /><path d="M42.085 66.332l-4.937 6.987.348.245 4.938-6.987z" /><path d="M42.788 67.964l-1.67 7.714.423.216 3.9-7.615-.346-.18-3.293 6.43 1.56-7.317-.496-.254-3.9 7.614.347.178z" /><path d="M47.02 68.676c-.956-.27-1.6.515-1.934 1.704l-1.182 4.213c-.334 1.188-.192 2.193.764 2.46.956.27 1.6-.515 1.934-1.703l.264-.942-.393-.11-.274.977c-.25.882-.693 1.47-1.38 1.276-.69-.192-.763-.924-.515-1.807l1.202-4.283c.248-.883.695-1.48 1.383-1.288.687.193.758.937.51 1.82l-.2.717.392.11.192-.683c.333-1.19.19-2.193-.765-2.46z" /><path d="M48.58 73.126l.3-3.434 2.126.186.044-.512-2.55-.222-.744 8.523 2.55.223.045-.512-2.124-.185.31-3.556 1.765.154.046-.51z" /><path d="M55.055 77.55l.42-.07-1.386-8.454-.33.054c-.063.654-.274 1.197-.896 1.36l.08.483c.42-.12.717-.44.88-.875z" /><path d="M56.237 68.352c-.934.337-1.033 1.347-.606 2.53l.354.978c.41 1.138 1.06 1.84 1.914 1.53.54-.194.8-.573.775-1.24l.714 1.977c.344.955.306 1.696-.375 1.942-.672.24-1.17-.293-1.486-1.167l-.045-.127-.383.14.037.102c.423 1.173 1.128 1.867 2.06 1.53.953-.343 1.034-1.347.603-2.543l-1.478-4.092c-.428-1.184-1.14-1.902-2.083-1.56zm.178.494c.672-.243 1.175.303 1.49 1.177l.353.977c.316.874.277 1.616-.395 1.858-.672.243-1.174-.304-1.49-1.177l-.352-.976c-.315-.874-.277-1.616.395-1.858z" /><path d="M58.905 67.104c-.86.516-.703 1.55-.067 2.607l.283.472.35-.21-.3-.503c-.473-.786-.63-1.55-.017-1.917.637-.382 1.21.086 1.72.934 1.21 2.01-.492 3.79 1.064 6.377l.214.356 2.355-1.415-.265-.44-1.988 1.196-.05-.083c-1.274-2.172.297-4.115-.975-6.23-.643-1.07-1.455-1.664-2.322-1.143z" /><path d="M66.402 72.346l.324-.292-4.044-7.202-.344-.38-2.093 1.89.353.39 1.77-1.598z" /></g><path d="M34.343 28.863l1.375 1.493-1.99.396-.996 1.768-.992-1.77-1.99-.4 1.38-1.49-.235-2.016 1.843.85 1.844-.846-.24 2.015M69.483 28.863l1.374 1.493-1.99.396-.997 1.768-.99-1.77-1.99-.4 1.378-1.49-.235-2.016 1.844.85 1.844-.846-.237 2.015M32.663 66.905l1.374 1.493-1.99.395-.995 1.77-.992-1.772-1.99-.4 1.378-1.49-.234-2.015 1.843.85 1.845-.846-.24 2.015M71.01 66.905l1.374 1.493-1.99.395-.995 1.77-.993-1.772-1.99-.4 1.378-1.49-.234-2.015 1.844.85 1.845-.846-.24 2.015M50.792 33.97c-.09.203-.212.398-.39.528-.16.12-.357.192-.558.216-.41.048-.847-.105-1.107-.434-.155-.196-.235-.44-.25-.686-.06-.993.82-1.562 1.717-1.414.316.052.578.32.71.6.075.16.094.3.076.474-.02.185-.06.366-.125.54-.022.057-.046.117-.073.176zm12.72 2.82c-2.712-4.382-7.133-5.778-11.874-5.622-.274-.257-.637-.45-1.122-.528-4.943-.795-10.65 3.494-13.685 6.996-.086.102.056.25.15.15 3.09-3.298 8.752-6.107 10.868-6.51.482-.1 1.192-.05 1.91.04-2.446.418-2.804 4.022-.04 4.15 1.922.09 3.05-2.364 2.29-3.82.11.01.212.02.284.018 1.522-.03 2.95.087 4.382.497 2.695.772 4.77 2.692 6.39 4.89.194.26.626.028.447-.26M49.564 61.28c.09-.202.213-.396.39-.528.162-.12.36-.192.558-.215.412-.05.848.105 1.108.434.155.197.235.44.25.687.06.992-.82 1.562-1.717 1.414-.317-.052-.578-.32-.71-.598-.075-.16-.094-.302-.076-.477.02-.183.06-.364.125-.537.022-.06.046-.12.073-.178zm-12.718-2.818c2.71 4.38 7.132 5.778 11.873 5.62.273.257.636.45 1.12.53 4.945.793 10.65-3.496 13.686-6.998.088-.1-.056-.248-.15-.148-3.09 3.296-8.75 6.105-10.867 6.507-.483.1-1.192.05-1.91-.04 2.446-.416 2.802-4.02.038-4.15-1.92-.088-3.048 2.365-2.29 3.822-.108-.01-.212-.02-.284-.02-1.522.033-2.95-.086-4.382-.496-2.694-.772-4.77-2.692-6.39-4.888-.194-.262-.624-.03-.446.26M51.14 89.475c.784.204 1.78-.056 2.577-.175.15-.022.15-.28 0-.304-.796-.12-1.793-.378-2.576-.174-.323.084-.323.57 0 .653" fill="#463833"/></svg> -->
			<img class="label" src="../../assets/static/images/jabka_250ml.png" height="auto" width="100">
			<div class="text1">
				<div class="text-content">
					<h1 class="title">Jabka sok 250 ml</h1>
					<!-- <div class="body-text">100% organic apple juice from Topaz apples, an old apple variety that is considered a jewel among apples. These extremely beautiful and tasty apples have an excellent aroma and long-lasting freshness.</div> -->
					<div>
						<v-chip-group>
							<v-chip>{{ $t('wholesale_price') }}: <strong style="margin-left: 3px;"> 1.5 EUR</strong></v-chip>
						</v-chip-group>
						<div class="suggSellingPrice">
							<div style="font-size:0.75rem; text-align: left; text-transform: lowercase;">({{ $t('sugg_selling_price') }}: 2.5 EUR)</div>
						</div>
						<!-- <v-chip-group>
							<v-chip>{{ $t('moq') }}: 12 kom</v-chip>
						</v-chip-group> -->
					</div>
					<v-card-actions>
						<v-btn 
							class="readMoreBtn"
							@click="showDetails = true"
						>
							{{ $t('readMore') }}
						</v-btn>
					</v-card-actions>
				</div>
			</div>
			<svg class="chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 35" width="30"><path d="M5 30L50 5l45 25" fill="none" stroke="#000" stroke-width="5"/></svg>
		</div>
		<v-row justify="center">
			<v-dialog 
				v-model="showDetails" 
				width="800"
				transition="dialog-bottom-transition">
				<v-card style="padding: 20px; margin: auto;">
					<v-img
						src="../../assets/static/images/jabka_250ml.png"
						width="200px"
						style="float: left; margin: 5px;"
						cover
					></v-img>
					<v-card-text style="text-align:justify; overflow: hidden;">100% organic apple juice from Topaz apples, an old apple variety that is considered a jewel among apples. These extremely beautiful and tasty apples have an excellent aroma and long-lasting freshness.</v-card-text>
					<div style="text-align: left">
						<div class="card-title bold">Jabka sok 250 ml</div>
						<v-card-subtitle style="padding-top: 0px; text-transform: uppercase;">Naravni sokovi</v-card-subtitle>
						<v-card-text style="padding-bottom: 0px;">Šmartno v Rožni dolini, 3201 CELJE</v-card-text>
					</div>
					<v-divider class="mx-4 mb-1"></v-divider>
					<div class="px-4">
						<v-chip-group>
							<v-chip>{{ $t('wholesale_price') }}: <strong style="margin-left: 3px;"> 1.5 EUR</strong></v-chip>
						</v-chip-group>
						<div class="suggSellingPrice">
							<div style="text-align: left; text-transform: lowercase;">({{ $t('sugg_selling_price') }}: 2.5 EUR)</div>
						</div>
						<v-chip-group>
							<v-chip>{{ $t('moq') }}: 12 kom</v-chip>
						</v-chip-group>
					</div>
					<v-card-actions>
						<v-btn 
							class="sendInquiryBtn"
							@click="openProductInquiryForm(product)"
							>
							{{ $t('sendInquiry') }}
						</v-btn>
						<button class="add-btn2" variant="text" @click="showDetails = false">{{ $t('dismiss') }}</button>
					</v-card-actions>
				</v-card>
			</v-dialog>		
		</v-row>

	</div>
</template>

<script>
	export default {
		data() {
		return {
			loading: false,
			showDetails: false,
		}
	},
	methods: {
		openProductInquiryForm(data) {
			this.$emit('open-product-inquiry-form', data)
		},
		reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      },
	},
	props: {
		product: {
			type: Object,
			default: () => {
				return {}
			}
		},
		clientId: {
			type: Number
		},
		parentProductIds: {
			type: Object,
			default: () => {
				return {}
			}
		}
	}
	}
</script>

<style lang="scss" scoped>
body {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
//   font-family: sans-serif;
  margin: 0;
//   background: #6D6027;
//   background: -webkit-linear-gradient(left, #D3CBB8, #6D6027);
//   background: -o-linear-gradient(left, #D3CBB8, #6D6027);
//   background: linear-gradient(to right, #D3CBB8, #6D6027);
}
@media (max-width: 767px) {
  body {
    display: block;
  }
}
.card {
  border-radius: 8px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  cursor: pointer;
  height: 180px;
  margin: 10px;
  padding: 0 10px;
  position: relative;
  -webkit-tap-highlight-color: rgba(0,0,0,0.025);
  text-align: center;
  transition: height 1000ms;
  width: 260px;
}
.card:hover  { 
	background: grey;
}

.sendInquiryBtn {
	background-color: var(--bg-light) !important;
    border: none;
    color: var(--bright);
    box-shadow: none;
    font-weight: 600;
}
.add-btn2 {
	background: var(--primaryDark);
	color: var(--bright);
    padding: 0.5em;
    letter-spacing: 3px;
    width: auto;
    border-radius: 10px;
    margin: auto;
}

.readMoreBtn {
	background-color: none !important;
    border: none;
    color: var(--bg-light);
    box-shadow: none;
    font-weight: 600;
}
@media (max-width: 767px) {
  .card {
    left: calc(50% - 20px);
    transform: translateX(-50%);
  }
}
.card.expanded {
  height: 300px;
  background: white;
}
.label {
  margin-top: 30px;
  margin: auto;
  transform: translateY(10px);
  transition: transform 1000ms;
}
.card.expanded .label {
  transform: translateY(0);
}
.text1 {
  clip-path: polygon(0% 100%, 0 -90%, 50% -5%, 100% -90%, 100% 100%);
  -webkit-clip-path: polygon(0% 100%, 0 -90%, 50% -5%, 100% -90%, 100% 100%);
  transition: clip-path 1000ms;
}
.card.expanded .text1 {
  clip-path: polygon(0% 100%, 0 -100%, 50% -15%, 100% -100%, 100% 100%);
  -webkit-clip-path: polygon(0% 100%, 0 -100%, 50% -15%, 100% -100%, 100% 100%);
}
.text2 {
  clip-path: polygon(0% 100%,0% -80%,15% -70%,17.23% -53.59%,23% -40%,27.23% -28.94%,35% -20%,41.09% -13.59%,50% -10%,58.91% -13.23%,65% -20%,72.77% -28.23%,77% -40%,82.77% -54.65%,85% -70%,100% -80%,100% 100%);
  -webkit-clip-path: polygon(0% 100%,0% -80%,15% -70%,17.23% -53.59%,23% -40%,27.23% -28.94%,35% -20%,41.09% -13.59%,50% -10%,58.91% -13.23%,65% -20%,72.77% -28.23%,77% -40%,82.77% -54.65%,85% -70%,100% -80%,100% 100%);
  transition: clip-path 1000ms;
}
.card.expanded .text2 {
  clip-path: polygon(0% 100%,0% -90%,15% -80%,17.23% -63.59%,23% -50%,27.23% -38.94%,35% -30%,41.09% -23.59%,50% -20%,58.91% -23.23%,65% -30%,72.77% -38.23%,77% -50%,82.77% -64.65%,85% -80%,100% -90%,100% 100%);
  -webkit-clip-path: polygon(0% 100%,0% -90%,15% -80%,17.23% -63.59%,23% -50%,27.23% -38.94%,35% -30%,41.09% -23.59%,50% -20%,58.91% -23.23%,65% -30%,72.77% -38.23%,77% -50%,82.77% -64.65%,85% -80%,100% -90%,100% 100%);
}
.text-content {
  transform: translateY(-300px);
  transition: transform 1000ms;
}
.card.expanded .text-content {
  transform: translateY(-15px);
}
.chevron {
  position: absolute;
  bottom: 20px;
  left: calc(50% - 15px);
  transform-origin: 50%;
  transform: rotate(180deg);
  transition: transform 1000ms;
}
.card.expanded .chevron {
  transform: rotate(0deg);
}
.title {
  font-weight: 900;
  margin: 0px 0 5px;
}
.body-text {
  padding: 0 20px;
}

</style>